import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const ManuMasterForm = () => {
    const [showStatusForm, setShowStatusForm] = useState(false);
    const [data, setData] = useState([]);

    // select field
  const [selectedManuType, setSelectedManuType] = useState(null);
  const menu = [
    { name: 'Active', value: 1 },
    { name: 'In-Active', value: 2 },
    { name: 'Archive', value: 3 },
    { name: 'Reject', value: 4 },
    
];

    const data1 = [
        {
            statusNo: 1,
            statusName: 'Home Insurance',
            status: 1,
        },
        {
            statusNo: 2,
            statusName: 'Home Insurance',
            status: 2,
        },
        {
            statusNo: 3,
            statusName: 'Home Insurance',
            status: 3,
        }

    ]

    const formDialog = () => {
        setShowStatusForm(true);
    };
    useEffect(() => {
        setData(data1);
    }, []);
    const ActionBodyTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Menu" tooltipOptions={{ position: "top" }} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary mr-2" tooltip="Edit Menu" tooltipOptions={{ position: "top" }} onClick={() => { setEdit(true) }}></Button>
            </React.Fragment>
        );
    };
    return (
        <div>
            <h3>Menu Master</h3>
            <Button  className="pi pi-plus" onClick={() => formDialog()} >Create Menu</Button>
            <Dialog visible={showStatusForm} onHide={() => setShowStatusForm(false)}>

                <form className="p-fluid p-grid">
                    <div className="p-field col-6">
                        <label htmlFor="username">Menu Name</label>
                        <InputText id="username" aria-describedby="username-help" />
                        <label htmlFor="date"> Menu Type</label>
                        <span>
                        <Dropdown
                                name="status"
                                value={selectedManuType}
                                onChange={(e) => setSelectedManuType(e.value)}
                                options={menu}
                                optionLabel="name"
                                placeholder="Select menu type" />
                        </span>
                    </div>

                </form>

                <div style={{ float: 'right' }}>
                    <Button
                        type="button"
                        label="Cancel"
                        className="p-button-rounded p-default"
                        onClick={() => setShowStatusForm(false)}
                    />
                    <Button
                        type="submit"
                        label="Submit"
                        className="p-button-rounded"
                    />
                </div>
            </Dialog>
            <DataTable value={data}>
                <Column field="statusNo" header="S.NO"></Column >
                <Column field="statusName" header="Menu Name"></Column >
                <Column field="status" header="Menu Type"></Column >
                <Column header="Action" body={ActionBodyTemplate}></Column >
            </DataTable>
        </div>
    );
}
